import React from 'react';
import PercentCircleContainer from './styles';

const PercentCircle = ({ percent, step, cancel }) => {
  return (
    <PercentCircleContainer cancel={cancel} percent={percent}>
      <svg>
        <circle cx="21" cy="21" r="21"></circle>
        <circle step={step} cx="21" cy="21" r="21"></circle>
      </svg>
      <div class="number">{step} de 5</div>
    </PercentCircleContainer>
  );
};

export default PercentCircle;
